<template>
  <button :id="id">
    <div v-if="loading" class="text-center">
      <div class="animatedDots">
        <div class="animatedDotsChild" />
        <div class="animatedDotsItem" />
        <div class="animatedDotsInner" />
      </div>
    </div>
    <div class="button-text" v-else>
      <WhatsAppIcon />
      <p class="text-center text-white my-auto">
        {{ t("PAYJOY_CARD_VIEWS.WHATSAPP_BUTTON") }}
      </p>
    </div>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import WhatsAppIcon from "../assets/icons/WhatsAppIcon.vue";

export default defineComponent({
  name: "WhatsAppButton",
  components: {
    WhatsAppIcon,
  },
  props: {
    id: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style lang="scss" scoped>
@import "@/apps/credit-line/styles/index.scss";
$pj-color-alert-red: #e11d48;
button {
  background: #007c3b;
  border-radius: 5px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0px;
  color: $pj-color-white;
  width: 100%;
  border: none;
  height: 48px;
  padding: 10px 24px;
  font-family: Inter, serif;
}

.button-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

@keyframes bounce {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(-10px);
  }
}
</style>
